"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThunderDispatcherV3 = void 0;
const thunder_dispatcher_1 = require("../thunder-dispatcher");
class ThunderDispatcherV3 extends thunder_dispatcher_1.ThunderDispatcher {
}
exports.ThunderDispatcherV3 = ThunderDispatcherV3;
